import { useMemo } from "react";

interface AccountOption {
  title: string;
  value: string;
  status: string;
}

const allowedStatuses = ["reserved", "in_use"];
export const useAllowedAvcUsers = (accountList: AccountOption[]): AccountOption[] => {
  const filteredAvcUsers = useMemo(
    () => (accountList ?? []).filter(user => allowedStatuses.includes(user.status)),
    [accountList],
  );
  return filteredAvcUsers;
};
